<template>
  <vue-perfect-scrollbar
    class="bb-filter-popup"
    :class="{'bb-filter-popup_right': direction}"
    :style="positionStyle"
    ref="bbFilterPopup"
    @click.stop
  >
    <div class="bb-filter-popup-header" :class="{'bb-filter-popup-header_empty': !searchable}">
      <label class="bb-filter-popup-header-search" @click.stop v-if="searchable">
        <input class="bb-filter-popup-header-search__input bb-input bb-input_search"
               type="text"
               @input="searchByList"
               placeholder="Search">
        <i class="icon-search bb-filter-popup-header-search__icon"/>
      </label>
    </div>
    <div class="bb-filter-popup-wrapper">
      <div v-for="elem in currentList" :key="elem.id" class="bb-filter-popup-item">
        <checkbox class="bb-filter-popup__checkbox"
                  :checkbox-text="getName(elem)"
                  :flag="flags ? elem.id : flags"
                  :filter="true"
                  :name="elem"
                  :value="elem.isCheck ? elem.isCheck : elem.checked"
                  @checkboxChange="checkboxChange"/>
      </div>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Checkbox from '@/components/Main/Inputs/checkbox'
import {cloneDeep, trim, filter, get} from 'lodash'
import CountryFlag from '@/components/Main/CountryFlag/CountryFlag'

export default {
  name: 'FilterPopup',
  props: ['list', 'section', 'searchable', 'flags', 'checked', 'direction', 'positionStyle'],
  components: {
    CountryFlag,
    Checkbox,
    VuePerfectScrollbar
  },
  data () {
    return {
      currentList: []
    }
  },
  methods: {
    getName (elem) {
      return trim(elem.name) || trim(elem.username)
    },
    checkboxChange (data, item) {
      this.$emit('setData', data, item, this.section, this.list)
    },
    searchByList (e) {
      const search = e.target.value
      this.scrollTop()
      if (!search) {
        this.setList()
      } else {
        const regFilter = new RegExp(search, 'gmi')
        const regSort = new RegExp('^' + search, 'gmi')
        const filteredList = filter(this.list, item => {
          if (regFilter.test(item.name)) return item
        })
        this.currentList = filteredList.sort((a, b) => regSort.test(b.name) - regSort.test(a.name))
      }
    },
    scrollTop () {
      const scroll = get(this.$refs, 'bbFilterPopup.$el', '')
      if (!scroll) return
      scroll.scrollTop = 0
    },
    setList () {
      const checked = (this.checked || '').split(',')
      this.currentList = cloneDeep(this.list)
      if (!checked.length || !this.currentList) return
      this.currentList.forEach(item => {
        if (checked.includes(item.id.toString())) item.checked = true
      })
    }
  },
  watch: {
    list () {
      this.setList()
    },
    checked (newVal, oldVal) {
      this.setList()
    }
  },
  beforeMount () {
    this.setList()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-filter-popup {
    position: absolute;
    min-width: 115px;
    max-height: 185px;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    background-color: $color-white;
    padding: 0 15px 0;
    z-index: 99;
    overflow: hidden;
    white-space: nowrap;

    &_right {
      right: -150px;
    }

    &-header {
      position: sticky;
      top: 0;
      background-color: $color-white;
      padding: 15px 0;
      z-index: 1;

      &_empty {
        padding: 0;
        height: 15px;
      }

      &-search {
        position: relative;
        display: flex;
        align-items: center;
        background: $color-white;
        border: 1px solid $color-mercury;
        box-sizing: border-box;
        border-radius: 6px;

        &__input {
          width: 100%;
          height: 32px;
          padding-left: 40px;
        }

        &__icon {
          position: absolute;
          left: 13px;
          font-size: 15px;
          color: $color-silver;
        }
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &:after {
      position: absolute;
      content: '';
      top: 0;
      right: 25px;
      border: 5px solid transparent;
      border-bottom: 5px solid $color-white;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    }

    &__checkbox {
      margin-bottom: 13px;
    }
  }

</style>

<style lang="scss">
  .ps-container.bb-filter-popup {
    .ps__thumb-y,
    .ps__rail-y.ps--clicking .ps__thumb-y,
    .ps__rail-y:focus>.ps__thumb-y,
    .ps__rail-y:hover>.ps__thumb-y {
      width: 3px;
    }
    .ps__rail-y {
      right: 0;
      margin-bottom: 0;
      height: auto;
      margin-top: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/FilterPopup/FilterPopup.vue